@if (showLayout()) {
<app-navbar />
}
<router-outlet />
@if (showLayout()) {
  @defer (on idle) {
    <app-footer-deferred />
  } @placeholder {
    <div class="app-footer-placeholder" aria-hidden="true"></div>
  }
}
